module.exports = __webpack_public_path__ + "img/partner_bkvVszj.5a76717a.png";